export default {"src":"/_next/static/media/pumpkin.8183ef4a.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};